import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { formatApiError } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate("/admin/login"), 2000);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full px-4 py-3 rounded-xl bg-[#1B0F2E] border border-[#3B2760] text-[#F5EFE6] placeholder-[#A08FB8] focus:outline-none focus:border-[#FF2E88]";

  return (
    <div className="min-h-screen bg-[#1B0F2E] text-[#F5EFE6] flex items-center justify-center px-6">
      <div data-testid="reset-password-page" className="w-full max-w-sm bg-[#26153F] border border-[#3B2760] rounded-2xl p-8">
        <h1 className="display-type text-2xl font-bold uppercase mb-6 text-center">Choose New Password</h1>
        {done ? (
          <p data-testid="reset-success" className="text-sm text-[#2DE2E6] text-center">
            Password updated. Redirecting to sign in…
          </p>
        ) : (
          <form data-testid="reset-form" onSubmit={submit} className="space-y-4">
            <input
              data-testid="reset-password-input"
              type="password"
              required
              minLength={8}
              placeholder="New password (min 8 characters)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={inputCls}
            />
            <input
              data-testid="reset-confirm-input"
              type="password"
              required
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className={inputCls}
            />
            {error && <p data-testid="reset-error" className="text-sm text-[#FF2E88]">{error}</p>}
            <button
              data-testid="reset-submit-button"
              type="submit"
              disabled={busy || !token}
              className="w-full py-3 rounded-xl bg-[#FF2E88] text-white font-bold uppercase mono-lbl text-sm hover:bg-[#D61F73] transition-colors disabled:opacity-50"
            >
              {busy ? "Updating…" : "Update Password"}
            </button>
          </form>
        )}
        <Link to="/admin/login" className="block text-center text-xs text-[#A08FB8] hover:text-[#F5EFE6] mt-6">
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
